export default "__VITE_ASSET__QQ6wFWF5__"